<div class="container-buttons">
  <button mat-raised-button (click)="openVideoModal()">
    <mat-icon>video_file</mat-icon>
    Tutoriel versement
  </button>

  <button *ngFor="let button of boutons"
          mat-raised-button
          [routerLink]="button.url">
    <mat-icon>{{button.icon}}</mat-icon> {{button.titre}}
  </button>
</div>
